import { Box, Button, Modal } from '@mui/material'
import { useAdmin } from 'contexts/AdminProvider'
import React from 'react'
import Header from 'components/Header'
import { GridRowParams } from '@mui/x-data-grid'
import { useNavigate } from 'react-router'
import { adminPracticeDetailURL } from 'routes/urls'
import AdminPracticeTable from 'components/AdminPracticeTable'
import Practice from 'logic/Practice'
import CreatePracticeModal from './CreatePracticeModal'

const AdminPracticeList: React.FC = () => {
  const navigate = useNavigate()
  const { 
    practiceSearchForm, 
    practiceSelection, 
    practiceColumnVisibilityModel, 
    practiceSortModel, 
    updatePracticeSearchForm, 
    setPracticeSelection, 
    setPracticeColumnVisibilityModel, 
    setPracticeSortModel 
  } = useAdmin()

  const [open, setOpen] = React.useState<boolean>(false)

  const onRowClick = React.useCallback((params: GridRowParams<Practice>) => {
    navigate(adminPracticeDetailURL(params.row.practice_id))
  }, [navigate])

  const onCreate = React.useCallback(() => {
    setOpen(true)
  }, [setOpen])

  const onClose = React.useCallback(() => {
    setOpen(false)
  }, [setOpen])

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, height: '100%' }}>
      <Header text='Practice List'>
        <Button variant='contained' color='primary' onClick={onCreate}>Create Practice</Button>
      </Header>
      <AdminPracticeTable
        onRowClick={onRowClick}
        form={practiceSearchForm}
        updateForm={updatePracticeSearchForm}
        selection={practiceSelection}
        setSelection={setPracticeSelection}
        columnVisibilityModel={practiceColumnVisibilityModel}
        setColumnVisibilityModel={setPracticeColumnVisibilityModel}
        sortModel={practiceSortModel}
        setSortModel={setPracticeSortModel}
      />
      <Modal open={open} onClose={onClose}>
          <CreatePracticeModal onCancel={onClose} />
      </Modal>
    </Box>
  )
}

export default AdminPracticeList